(function($) { "use strict";

	$(document).ready(function(){"use strict";
		
		var progressPath = document.querySelector('.progress-wrap path');
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 50;
		var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			jQuery('html, body').animate({scrollTop: 0}, duration);
			return false;
		})
		
		
	});
	
})(jQuery);
$(document).ready(function () {
  jQuery('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<section class="cart-page-sec pt"><div class="container"><div class="order-historycontent"></div></div></section>');
  jQuery('.cart-page-section .section-title.main').prependTo('.cart-page-section > .container');
var contentDiv = $('#WebPixelsManagerSandboxContainer');
  $('footer').after(contentDiv)
  countDownIni('.flip-countdown,.js-flip-countdown'); 
  countDownIni1('.flip-countdowns,.js-flip-countdowns'); 
  //jQuery('.view-product-sec').appendTo('body.product .wrapper ');
  /********* On scroll heder Sticky *********/
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
      $("header").addClass("head-sticky");
    } else {
      $("header").removeClass("head-sticky");
    }
  });
  /********* layout js *********/
    $('.demo-btn').on('click', function (e) {
      $('body').addClass('no_scroll');
      $('.layout-section').addClass('open');
    });
    $('.demo-close').on('click', function (e) {
      $('body').removeClass('no_scroll');
      $('.layout-section').removeClass('open');
    });
  /********* Mobile Menu ********/
  $('.mobile-menu-button').on('click', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('body').addClass('no-scroll active-menu');
      $(".mobile-menu-wrapper").toggleClass("active-menu");
      $('.overlay').addClass('menu-overlay');
    }, 50);
  });
  $('body').on('click', '.overlay.menu-overlay, .menu-close-icon svg', function (e) {
    e.preventDefault();
    $('body').removeClass('no-scroll active-menu');
    $(".mobile-menu-wrapper").removeClass("active-menu");
    $('.overlay').removeClass('menu-overlay');
  });
  
  /********* Mobile Filter Popup ********/
 $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll');
      $('.overlay').removeClass('active');
    });    
    var $this = $('.collection');
    if ($this.hasClass("collection-leftfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
    var $this = $('.collection');
    if ($this.hasClass("collection-rightfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
   /*********  Multi-level accordion nav  ********/
  $('.acnav-label').click(function () {
    var label = $(this);
    var parent = label.parent('.has-children');
    var list = label.siblings('.acnav-list');
    if (parent.hasClass('is-open')) {
      list.slideUp('fast');
      parent.removeClass('is-open');
    }
    else {
      list.slideDown('fast');
      parent.addClass('is-open');
    }
  });
   /********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").removeClass("product-list-view");
      $(".grid-product .row").addClass("product-grid-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-top-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.pro-labl').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content .product-description ');
        jQuery(this).find('.product-offer-timeline').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-bottom-content').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.rating-wrp').prependTo(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.product-card-social-icon').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.price').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-card-social-icon');
        jQuery(this).find('.size-select').insertAfter(prod_img);
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-list-view");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.product-list-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-content');
        jQuery(this).find('.product-top-content').prependTo(prod_img);
         var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-labl').appendTo(prod_img);
         var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-offer-timeline').appendTo(prod_img);
         var prod_img = jQuery(this).find('.product-content');
        jQuery(this).find('.product-bottom-content').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content h3');
        jQuery(this).find('.rating-wrp').insertBefore(prod_img);
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-card-social-icon').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.price').prependTo(prod_img);
         var prod_img = jQuery(this).find('.price');
        jQuery(this).find('.size-select').insertAfter(prod_img);
      });
    });
  /****  TAB Js ****/
  $("ul.tabs li").click(function () {
    var $this = $(this);
    var $theTab = $(this).attr("data-tab");
    if ($this.hasClass("active")) {
    } else {
      $this
        .closest(".tabs-wrapper")
        .find("ul.tabs li, .tabs-container .tab-content")
        .removeClass("active");
      $(
        '.tabs-container .tab-content[id="' +
        $theTab +
        '"], ul.tabs li[data-tab="' +
        $theTab +
        "]"
      ).addClass("active");
    }
    $(this).addClass("active");
  });

  /*********  Header Search Popup  ********/
  $(".search-header a").click(function () {
    $(".search-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-search").click(function () {
    $(".search-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  /********* Cart Popup ********/
 $('.main-cart').on('click', function (e) {
      $('body').addClass('no-scroll cartOpen');
        $('.disclosure__list-wrapper').addClass('hide');
    });
    $('body').on('click', '.overlay.cart-overlay, .mini-cart-header, .closecart', function (e) {
        $('body').removeClass('no-scroll cartOpen');
        $('.coupon-popup').removeClass('active');
        $('.gift-popup').removeClass('active');
    });
    $(".mini-cart-has-item").click(function(event){
      event.stopPropagation();
    });
/*********  size Popup  ********/ 
    $(".size-btn").click(function() { 
      $(".size-popup").toggleClass("active");   
      $("body").toggleClass("no-scroll");
  });
  $(".close-search").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
  });
  $(".close-btn").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
  });
 /*********coupon popup ********/
  $(".coupan-icon").click(function () {
  $(".coupon-popup").toggleClass("active");
  $("body").toggleClass("no-scroll");
  });
  $(".close-coupon").click(function () {
    $(".coupon-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });

  /*********gift popup ********/
  $(".gift-icon").click(function () {
    $(".gift-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-gift").click(function () {
    $(".gift-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  }); 

  /*********  ask qustion Popup  ********/
  $(".pro-features li.ask-qus").click(function () {
    $(".ask-qus-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-search").click(function () {
    $(".ask-qus-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
 // currency
  function currencyFormSubmit(event) {
      event.target.form.submit();
    }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
      element.addEventListener('change', currencyFormSubmit);
    });
   /******* quick-view-popup Js *******/

   $('body').on('click', '.quick-close-btn', function(e) {
    e.preventDefault();
     $(".quick-view-popup").removeClass("active");
     $("body").removeClass("no-scroll");
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
        var swiper = new Swiper(".quickview-img-slider", {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          speed: 800,
          navigation: {
            nextEl: ".quickview-next-btn.swiper-button-next",
            prevEl: ".quickview-prev-btn.swiper-button-prev",
          },
          breakpoints: {
            992: {
              slidesPerView: 1,
            },
            0: {
              slidesPerView: 1,
            }
          },
        });

    });
    $(".quick-view-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  
$('body').on('click', '.quickview_popup_data .radio-buttons .button', function() {
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .radio-buttons .button input:checked').each(function() {
    var selectedValue = $(this).val();
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Convert variant_title to a string to ensure type consistency
    variant_title = String(variant_title);

    // Check if variant_title exists in the selectedValues array
    if (selectedValues.includes(variant_title)) {
      var variantImageIndex = $('.quickview-img-slider .img-wrapper img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-img-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add to Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
        $('.quickview_popup_data .quantity-select').show();
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
        $('.quickview_popup_data .quantity-select').hide();
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
  // end quickview //

   // custom review
  setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab-sec').find("li.active").removeClass('active');
    $('.pdp-tab-sec').find("li[data-tab='pdp-tab-3']").addClass('active');
    $('.pdp-tab-sec .tab-content.active').removeClass('active');
    $(".pdp-tab-sec .tab-content[id='pdp-tab-3']").addClass('active'); 
    });
  }, 1000); 
  
    // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
   var swiper = new Swiper(".related-sidebar-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      475: {
        slidesPerView: 1,
      },
    },
  });
  
   // coupan code
  $('body').on('keyup','.discount_coupan', function() {
   var apply_href = $('.apply').attr("href").split('discount=')[0];
   var val = $(this).val();
    $('.apply').attr("href",apply_href+'discount='+val);
  });

  // load-more button scroll
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val()),
      datacollurl = $('[data-coll-url]').val();
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('[data-next-link]').val(datacollurl + "?page="+next_coll);
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.product-list-view, .product-grid-view').append($(responseHTML).find('.product-list-view, .product-grid-view').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

         jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-top-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.pro-labl').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content .product-description ');
        jQuery(this).find('.product-offer-timeline').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-bottom-content').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.rating-wrp').prependTo(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.product-card-social-icon').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.price').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-card-social-icon');
        jQuery(this).find('.size-select').insertAfter(prod_img);
      });
      
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    
   $(".menu-lnk.has-item").hover(function () {
    $('body').toggleClass("no-scroll");
 });
  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-grid-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });
  
  // product slider zoom
    $('.product-item-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 1
      });
    });

 // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products_add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products_add-cart-sticky').addClass('show-btn');
        }
    });
    }

    $('body').on('click','.show-btn .sticky-btn', function(e) {
      e.preventDefault();
      $('.cart-btn.product-button').trigger("click");
    });

$('body').on('click','.products_add-cart-sticky .button', function() {
      $(this).closest('.radio-buttons').find('label.sticky-active').removeClass('sticky-active');
      $(this).find("label").addClass("sticky-active");
});

// $('.pdp-page-main-sec .button').on('click', function() {
//   var selectedRadio = $(this).find('input[type="radio"]:checked');
  
//   if (selectedRadio.length > 0) {
//     var valueToTrigger = selectedRadio.val();
//     $('.products_add-cart-sticky .button input[value="' + valueToTrigger + '"]').click();
//   }
  
// });


$('.pdp-page-main-sec .select__select').on('change', function() {
    var selectedValue = $(this).val();
    
    $('.products_add-cart-sticky .select__select option').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).prop('selected', true);
      } else {
        $(this).prop('selected', false);
      }
    });
    // $('.products_add-cart-sticky .select__select').trigger('change');
  });


$('.products_add-cart-sticky .select__select').on('change', function() {
    var selectedValue = $(this).val();
    
    // Find the corresponding option in the first select element and select it
    $('.pdp-page-main-sec .select__select option').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).prop('selected', true);
      } else {
        $(this).prop('selected', false);
      }
    });
  });

// end sticky
  // infinit scroll
function initializeAjaxinate(containerSelector) {
  var endlessScroll = new Ajaxinate({
    container: containerSelector,
    pagination: '#collection-Pagination',
    loadingText: '<img src="https://cdn.shopify.com/s/files/1/0751/3771/2446/files/813.gif?v=1692071901" class="infinity-loader">',
    callback: callbackInfiniteScroll
  });
}

function callbackInfiniteScroll() {
  countDownIni('.flip-countdown,.js-flip-countdown');

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-top-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.pro-labl').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content .product-description ');
        jQuery(this).find('.product-offer-timeline').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-bottom-content').insertAfter(prod_img);
         var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.rating-wrp').prependTo(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.product-card-social-icon').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.rating-wrp');
        jQuery(this).find('.price').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-card-social-icon');
        jQuery(this).find('.size-select').insertAfter(prod_img);
      });
}
document.addEventListener("DOMContentLoaded", function() {
  initializeAjaxinate('.product-list-view');

  const list_view = document.querySelector(".list-view");
  if(list_view){
      list_view.addEventListener('click', function(event) {
    if (event.target.classList.contains('product-grid-view')) {
      initializeAjaxinate('.product-grid-view');
    }
  });
  }
  
});
  /** Food Category slider **/
  var swiper = new Swiper(".food-category-slider", {
    slidesPerView: 6,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      prevEl: ".food-prev-btn.swiper-button-prev",
      nextEl: ".food-next-btn.swiper-button-next",
    },
    breakpoints: {
      1100: {
        slidesPerView: 6,
      },
      992: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 4,
      },
      420: {
        slidesPerView: 3,
      },
      320: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 2,
      },
    },
  });
  /** Popular Product slider **/
  var swiper = new Swiper(".popular-product-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".popular-product-next-btn.swiper-button-next",
      prevEl: ".popular-product-prev-btn.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      575: {
        slidesPerView: 2,
      },
      420: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      }
    },
  });
  /** Daily Deal slider **/
  var swiper = new Swiper(".deal-swiper-slider", {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".daily-deal-next-btn.swiper-button-next",
      prevEl: ".daily-deal-prev-btn.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
      },
      575: {
        slidesPerView: 2,
      },
      420: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      }
    },
  });
  /** Most popular Category slider **/
  var swiper = new Swiper(".most-popular-category-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".popular-category-next-btn.swiper-button-next",
      prevEl: ".popular-category-prev-btn.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      420: {
        slidesPerView: 1,
      },
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
  /** Testimonial slider **/
  var swiper = new Swiper(".testimonial-slider", {
    slidesPerView: 2,
    spaceBetween: 15,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".testimonial-next-btn.swiper-button-next",
      prevEl: ".testimonial-prev-btn.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  /** Blog slider **/
  var swiper = new Swiper(".blog-slider", {
    slidesPerView:3,
    spaceBetween: 15,
    loop: true,
    speed: 800,
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      510: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    
    },
  });
  /** partnert logo slider **/
  var swiper = new Swiper(".partner-logo-slider", {
    slidesPerView: 5,
    spaceBetween: 15,
    loop: true,
    centeredSlides: false,
    speed: 800,
    navigation: {
      nextEl: ".partner-logo-next.swiper-button-next",
      prevEl: ".partner-logo-prev.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 4,
      },
      475: {
        slidesPerView: 3,
      },
      350: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
  
  /** Popular Product slider **/

  var swiper = new Swiper(".elegant-product-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      575: {
        slidesPerView: 1,
      },
      420: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  /** product page slider **/
  var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-left")) {
    var galleryThumb = new Swiper(".gallery-thumbs-left", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "vertical",
      breakpoints: {
        992: {
          direction: 'vertical',
        },
        768: {
          direction: 'horizontal',
          slidesPerView: 3,
          spaceBetween: 30,
        },
        576: {
          direction: 'horizontal',
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal',
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-left", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumb
      }
    });
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumb.slideTo(galleryMain.activeIndex);
    });
    galleryThumb.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumb.activeIndex);
    });
}
  var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-right")) {
    var galleryThumb = new Swiper(".gallery-thumbs-right", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "vertical",
      breakpoints: {
        992: {
          direction: 'vertical',
        },
        768: {
          direction: 'horizontal',
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal',
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal',
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-right", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumb
      }
    });
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumb.slideTo(galleryMain.activeIndex);
    });
    galleryThumb.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumb.activeIndex);
    });
}
  var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-center")) {
    var galleryThumb = new Swiper(".gallery-thumbs-center", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "horizontal",
      breakpoints: {
        992: {
          direction: 'horizontal',
        },
        768: {
          direction: 'horizontal',
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal',
          slidesPerView: 4,
          spaceBetween: 30,
        },
        320: {
          direction: 'horizontal',
          slidesPerView: 3,
          spaceBetween: 15,
        },
        0: {
          direction: 'horizontal',
          slidesPerView: 2,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-center", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumb
      }
    });
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumb.slideTo(galleryMain.activeIndex);
    });
    galleryThumb.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumb.activeIndex);
    });
}
var $this = $('.pdp-left-column');
  if ($this.hasClass("product-noslider")) {
    var galleryMain = new Swiper(".gallery-noslider", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  ///// about-service-slider
  var swiper = new Swiper(".about-service-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: false,
    speed: 800,
    // autoplay:true,
    navigation: {
      nextEl: ".about-service-next-btn.swiper-button-next",
      prevEl: ".about-service-prev-btn.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  /** Popular Product slider **/
  var swiper = new Swiper(".our-team-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".our-team-next-btn.swiper-button-next",
      prevEl: ".our-team-prev-btn.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      420: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      }
    },
  });

  /********* back to top ********/    
   var btn = $('#button');

   $(window).scroll(function() {
     if ($(window).scrollTop() > 300) {
       btn.addClass('show');
     } else {
       btn.removeClass('show');
     }
   });
   
   btn.on('click', function(e) {
     e.preventDefault();
     $('html, body').animate({scrollTop:0}, '300');
   });
 
   /********* mobile stickybar ********/
   $(window).scroll(function() {
     if ($(window).scrollTop() > 300) {
       $(".mobile-stickybar").addClass('show');
     } else {
       $(".mobile-stickybar").removeClass('show');
     }
   });
  
  /** footer acnav **/
  $('.acnav-label1').click(function (event) {
    event.preventDefault();
    if(jQuery( window ).width() < 768) {
      var label = $(this);
      var parent = label.parent('.has-children1');
      var list = label.siblings('.acnav-list1');
      if (parent.hasClass('is-open')) {
          list.slideUp('fast');
          parent.removeClass('is-open');
      }
      else {
          list.slideDown('fast');
          parent.addClass('is-open');
      }
    }
  });


  /********* Wrapper top space ********/
  $(window).on('load resize orientationchange', function() { 
    var header_hright = $('header').outerHeight();
    $('header').next('.wrapper').css('margin-top', header_hright + 'px');  
  }); 
         /** counter js **/
    $('.counting').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
    
    $({ countNum: $this.text()}).animate({
      countNum: countTo
    },

    {

      duration: 3000,
      easing:'linear',
      step: function() {
        $this.text(Math.floor(this.countNum));
      },
      complete: function() {
        $this.text(this.countNum);
      }
    });  
    });
  /******* Subscribe popup Js *******/
  $('.close-sub-btn').click(function () {
    $('.subscribe-popup').slideUp(); 
    $(".subscribe-overlay").removeClass("open");
  });
});

// ** product review js **//
function proreview() {
  var reviewform = document.getElementById("review-form");
  if (reviewform.style.display === "block") {
    reviewform.style.display = "none";
  } else {
    reviewform.style.display = "block";
  }
};
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span><span class="dots"></span></span>'));
      });
    }

  });
}
function countDownIni1 (countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<div class="days"><span class="count count-days" id="days"><b>%D</b></span><span class="counter-dtl">days</span></div>' + '<div class="hour"><span class="count count-hours" id="hours"><b>%H</b></span><span class="counter-dtl">hours</span></div>' + '<div class="mins"><span class="count count-minites" id="minutes"><b>%M</b></span><span class="counter-dtl">mins</span></div>' + '<div class="secs"><span class="count count-seconds" id="seconds"><b>%S</b></span><span class="counter-dtl">secs</span></div>'));
      });
    }

  });
}
